import React from "react";
import "./OurThesis.css";
import HubSpotForm from "../HubSpotForm/HubSpotForm";

function OurThesis() {
  const thesisSteps = [
    { title: "LEARNING", active: false },
    { title: "CERTIFICATION", active: true },
    { title: "HIRING", active: false },
    { title: "PERFORMANCE.", active: true },
  ];

  return (
    <section className="our-thesis-section py-5">
      <div className="container">
        <div className="text-center">
          <h2 className="section-title">Our Thesis</h2>

          <p>
            The next generation of workforce companies will not sell courses.
          </p>

          <p className="our-thesis-description mx-auto">
            They will build skills ontologies, talent knowledge graphs,
            AI-powered reasoning layers, skills wallets that travel with the
            learner, and infrastructure that connects
          </p>
        </div>

        {/* Desktop / Tablet Flow */}
        <div className="thesis-flow-wrapper d-none d-md-flex justify-content-center align-items-center mt-4 mb-4">
          {thesisSteps.map((step, index) => (
            <React.Fragment key={index}>
              <div className={`thesis-box ${step.active ? "active" : ""}`}>
                {step.title}
              </div>

              {index !== thesisSteps.length - 1 && (
                <div className="thesis-line"></div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Mobile Flow */}
        <div className="d-flex d-md-none flex-column align-items-center thesis-mobile-wrapper mt-4 mb-4">
          {thesisSteps.map((step, index) => (
            <React.Fragment key={index}>
              <div className={`thesis-box ${step.active ? "active" : ""}`}>
                {step.title}
              </div>

              {index !== thesisSteps.length - 1 && (
                <div className="thesis-line-vertical"></div>
              )}
            </React.Fragment>
          ))}
        </div>

        <p className="text-center mb-0">
          We invest in the builders creating that infrastructure.
        </p>
          <HubSpotForm />
      </div>
      
    </section>
  );
}

export default OurThesis;